import React, { useEffect } from 'react';

export default function Modal({ title, children, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 px-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-[420px] bg-surface-panel border border-surface-border p-[22px] relative rounded-[2px]"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute top-[10px] right-[14px] text-surface-muted hover:text-surface-text text-sm"
          aria-label="Close"
        >✕</button>
        <div className="text-[11px] font-bold uppercase tracking-[0.1em] text-surface-muted mb-[14px]">{title}</div>
        {children}
      </div>
    </div>
  );
}
